import { render, staticRenderFns } from "./preview-asset-gallery.vue?vue&type=template&id=550ac3fd&scoped=true&"
import script from "./preview-asset-gallery.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-gallery.vue?vue&type=style&index=0&id=550ac3fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ac3fd",
  null
  
)

export default component.exports